import { render } from "./ConfirmRemoveFromProfile.vue?vue&type=template&id=54162fbc"
import script from "./ConfirmRemoveFromProfile.vue?vue&type=script&lang=js"
export * from "./ConfirmRemoveFromProfile.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/irrigation/ConfirmRemoveFromProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54162fbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54162fbc', __exports__)) {
    console.log('reload')
    api.reload('54162fbc', __exports__)
  }
  
  module.hot.accept("./ConfirmRemoveFromProfile.vue?vue&type=template&id=54162fbc", () => {
    console.log('re-render')
    api.rerender('54162fbc', render)
  })

}


export default __exports__